import { render, staticRenderFns } from "./DialogFeedback.vue?vue&type=template&id=5940557a"
import script from "./DialogFeedback.vue?vue&type=script&lang=js"
export * from "./DialogFeedback.vue?vue&type=script&lang=js"
import style0 from "./DialogFeedback.vue?vue&type=style&index=0&id=5940557a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports